import { render, staticRenderFns } from "./tau.vue?vue&type=template&id=5cfc9b8a&"
import script from "./tau.vue?vue&type=script&lang=js&"
export * from "./tau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports